/* eslint-disable global-require */

require('@babel/polyfill');

if (typeof URLSearchParams !== 'function') {
  window.URLSearchParams = require('url-search-params');
}

// IE11 Custom properties polyfill
if (window.MSInputMethodContext && document.documentMode) {
  require('ie11-custom-properties');
}

// libraries
window._ = require('lodash');
window.moment = require('moment');

// Require extra locales we want `moment` to support.
require('moment/locale/es');
require('moment/locale/fr');
require('moment/locale/de');
require('moment/locale/pt');
require('moment/locale/it');
require('moment/locale/sv');
require('moment/locale/nl');
require('moment/locale/ru');
require('moment/locale/ja');
require('moment/locale/zh-cn');
require('moment/locale/ar');
require('moment/locale/tr');
require('moment/locale/vi');
require('moment/locale/zh-tw');
require('moment/locale/id');
require('moment/locale/fr-ca');
require('moment/locale/ko');

// Filipino: fil-PH in Rails
require('moment/locale/tl-ph');

// Tell `moment` to format dates locale-aware
if (window.I18n.locale === 'fil-PH') {
  window.moment.locale('tl-ph');
} else {
  window.moment.locale(window.I18n.locale);
}

// helpers
window.pubsub = require('./utils/pubsub').default();
window.replaceCAToken = require('./utils/centralAuthToken').replaceCAToken;

require('./utils/seismicMessageListen');
require('./utils/seismicBaseLinkHelper');
